/** @module csi/gallery/GalleryPlaceholder */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"csi/html",
	"csi/locale",
	"csi/widget/ActionsComboButton",
	"csi/widget/Automation",
	"dojo/text!csi/templates/galleryPlaceholder.html"
], function(declare, lang, _TemplatedMixin, _WidgetBase, html, locale, ActionsComboButton, Automation, template) {

	return declare([_WidgetBase, _TemplatedMixin], {
		templateString: template,

		/** @property {string} type - indicate whether placeholder is NoResult or Suspend */
		type: "NoResult",

		/** @property {number} height -  placeholder height */
		height: null,

		/** @property {string} titleText -  placeholder title */
		titleText: "",

		/** @property {string} description - placeholder description */
		description: "",

		/** @property {string} additionalText - large placeholder text underneath description */
		additionalText: "",

		/** @property {boolean} bImage - indicate placeholders image should display or not */
		bImage: false,

		/** @property {boolean} showActions - indicate whether placeholder should show actions or not */
		showActions: true,

		/** @property {ViewWidget} widget */
		widget: null,

		/**
		 * Create ActionsComboButton for provided list of cations
		 * @param {Action} defAction - button default action, must be provided
		 * @param {Action[]} actions - required element, might be empty array
		 * @param {DOMNode} node
		 * @param {View} widget
		 */
		createActionsButton: function(defAction, actions, node, widget) {
			var key = widget.defView.getHtmlKey();
			var createBtnId = "ActionsNew";
			new ActionsComboButton(Automation.params(key, "placeholder", createBtnId, {
				"class": "csi-secondary-cmb-btn csi-actions-new",
				materialIcon: 'add',
				label: locale.resource(defAction.getName()),
				actions: actions,
				onAction: lang.hitch(widget, "_onElementAction", node),
				onClick: lang.hitch(widget, "_onElementActionClick", node, defAction)
			})).placeAt(html.create("div", {"class": "csi-placeholder-actions"}, node));
		},

		postCreate: function() {
			var w = this.widget;

			if (this.height) {
				html.setPixels(this.domNode, html.HEIGHT, this.height);
			}

			if (this.bImage) {
				html.setVisible(this.imageBoxNode, true);
			}

			if (w && this.showActions) {
				// Add Actions Combo Button
				var qrRoot = w.getQueryResult();
				var ctx = qrRoot.getChildContext();

				var actions = qrRoot.getNewActions(ctx, false);
				var bActions = actions && actions.length;

				if (bActions) {
					var node = this.rootActionsNode;
					w.setQueryResultActionContext(qrRoot, ctx, node);
					html.setDataAttribute(node, "ButtonNewActions", true);
					var defAction = actions.shift();
					this.createActionsButton(defAction, actions, node, w);
				}
			}
		}
	});
});